import styled from "@emotion/styled";
import { CSS_MQ } from "../../../styles/breakpoints";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { fontColor, FONTS, fontSize } from "../../../styles/fonts";
import { capitalizeIfNoProductNameStyles, plainTextMdStyles } from "../../../styles/text-styles";
import { css } from "@emotion/react";

export const SeoHeadline = styled.span(
  FONTS.SwarovskiFutura500,
  fontColor.black,
  fontSize.x2,
  css`
    text-transform: uppercase;
    display: block;

    margin-bottom: 8px;
  `,
);

export const EmoHeadline = styled.span`
  ${FONTS.MinervaModern500};

  ${plainTextMdStyles};

  ${CSS_MQ.atLeastMd} {
    font-size: 30px;
    letter-spacing: 1.5px;
    line-height: 32px;
  }

  color: ${CSS_COLORS.Green};

  ${capitalizeIfNoProductNameStyles};
  display: block;

  margin-bottom: 20px;
`;
